const str = (value) => (value === null || value === undefined ? "" : String(value));

const byRow = (a, b) => (a.row ?? Infinity) - (b.row ?? Infinity);

export const importFailures = (data = {}) => {
  const failed = (Array.isArray(data?.results) ? data.results : [])
    .filter((item) => item?.status === "failed")
    .map((item) => ({
      row: Number(item.row) || null,
      name: str(item.name),
      reason: str(item.message) || "Could not import this row",
    }));

  const unreadable = (Array.isArray(data?.skippedRows) ? data.skippedRows : []).map(
    (item) => ({
      row: Number(item?.row) || null,
      name: str(item?.name),
      reason: str(item?.reason) || "Could not read this row",
    })
  );

  return [...failed, ...unreadable].sort(byRow);
};

export const importSkipped = (data = {}) =>
  (Array.isArray(data?.results) ? data.results : [])
    .filter((item) => item?.status === "skipped")
    .map((item) => ({
      row: Number(item.row) || null,
      name: str(item.name),
      reason: str(item.message) || "Already exists",
    }))
    .sort(byRow);

export const importSummary = (data = {}) => {
  const { created = 0, skipped = 0, failed = 0 } = data || {};
  const unreadable = Array.isArray(data?.skippedRows) ? data.skippedRows.length : 0;
  const totalFailed = failed + unreadable;

  return {
    level: totalFailed > 0 ? "warning" : created > 0 ? "success" : "info",
    message: `Import complete — ${created} created, ${skipped} skipped, ${totalFailed} failed.`,
  };
};
